//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      carouselResponsive: {
        0: {
          items: 1,
          nav: false,
          dots: true,
          margin: 30
        }
      }
    }
  },
  computed: {
    timelineItems () {
      return this.$t('how.derek.timeline')
    }
  },
  methods: {
    slideChanged (slide) {
      this.currentSlide = slide
    }
  }
}
